

export const index = 0;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/_layout.svelte.js')).default;
export const imports = ["_app/immutable/nodes/0.7be5237c.js","_app/immutable/chunks/scheduler.85e01571.js","_app/immutable/chunks/index.a7ffdff2.js"];
export const stylesheets = ["_app/immutable/assets/0.a4d469f9.css"];
export const fonts = ["_app/immutable/assets/roboto-regular.4e147ab6.ttf","_app/immutable/assets/roboto-medium.9d0d55a3.ttf","_app/immutable/assets/sofia-pro-regular.f3ef30c2.ttf","_app/immutable/assets/sofia-pro-bold.c6ba3583.ttf","_app/immutable/assets/sofia-pro-black.a8df3633.otf"];
